<template>
  <div>
    <div class="count_center">
      <h1>{{$t('i18n_Slogan')}}</h1>
      <img src="../../assets/userbg.png" alt="" />
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },

  methods: {},
  created() {},
  mounted() {},
};
</script>
<style scoped>
h1 {
  font-size: 24px;
  font-family: PingFang SC;
  font-weight: bold;
  color: #333333;
  padding: 54px;
  box-sizing: border-box;
}
.count_center {
  display: flex;
  display: -webkit-flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}
</style>



// WEBPACK FOOTER //
// src/components/PersonalCenter/userCountshow.vue